<template>
  <div class="browser-h5">
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted() {
    this.setRem();
  },
  methods: {
    setRem() {
      // 进入页面 初始化根节点字体大小，宽高rem,字体px
      let contentWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      // 假定1rem为1px =>（设备宽375）/（设计图宽750）
      // 注意bug qq、uc等浏览器最小根字体大小12px 放大100倍
      let fontSize = (contentWidth / 750) * 100;
      document.documentElement.style.fontSize = fontSize + "px";
      // alert(contentWidth + " " + fontSize);
      // console.log(contentWidth + " " + fontSize);
    },
  },
};
</script>

<style lang="less" scoped>
// 750设计图宽高除100 一半做的时候375 所以再除2
.browser-h5 {
  font-size: 16px;
  color: #333333;
}
</style>